<template>
  <div class="row justify-content-center" v-if="cargado">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center" v-if="!resultado">
          <img src="@/assets/mail_error.png" class="img-fluid" />
            <h3 class="rscolor">¡ Algo salió mal !</h3>
            No hemos podido verificar tu correo electrónico.
          </div>

<div class="text-center" v-if="resultado">
            <img src="@/assets/mail_verify.png" class="img-fluid" />
            <h3 class="rscolor">¡ Tu e-mail fue verificado correctamente !</h3>Ya podés utilizar esta dirección de correo electrónico para realizar gestiones y recibir notificaciones.
            <br/>Volvé a la pantalla en la que estabas, y presioná "YA LO VALIDE", para comenzar a usar tu billetera.         
          </div>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: {},
  name: "login",
  data() {
    return {
      resultado:false,
      cargado:false
    };
  },
  methods: {
    login() {}
  },
  beforeMount(){
let context = this;
axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/ValidateMail",
        {
          Code: context.$route.query.verificationCode,          
        },
        this,
        function(data) {
            context.cargado=true;
          context.resultado = data.ResponseVM.Resultado;
        }
      );

      console.log();
  }
};
</script>
<style>
			a
			{
				color: #ff4940;
			}

			a:hover
			{
				color: #c93961;
			}
			
			.btnVerify			
			{
				background: rgba(255,88,85,1);
				padding: 10px;
				border-radius: 5px;
				color:#fff;
				text-decoration: none;
				margin-top:20px;
				margin-bottom:20px;
			}

			.btnVerify:hover
			{
				background: rgba(201,57,98,1);
				color:#fff;
				text-decoration: none;
			}
			

			.rscolor
			{
				color: #ff4940;
			}
            h1, h2, h3, h4, h5
{
	color: #ff4940;
}

a
{
	color: #ff4940;
}

a:hover
{
	color: #c93961;
}

.tcpanel
{
	padding: 20px;	
	background-color: #f9f9f9;
}

.rscolor
{
	color: #ff4940;
}

.footer {
  background-color: #f5f5f5;
}

main
{
	margin-top:60px;
}

.logo
{
	max-height: 40px;
}

.rsgradient
{
	background: rgba(255,88,85,1);
	background: -moz-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,88,85,1)), color-stop(100%, rgba(201,57,98,1)));
	background: -webkit-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -o-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -ms-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: linear-gradient(to bottom, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff5855', endColorstr='#c93962', GradientType=0 );
}
</style>
